// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__lv0m+","checkbox__label":"Checkbox_checkbox__label__OA4US","checkbox__input":"Checkbox_checkbox__input__xlJJl"};